import React from 'react';
import {hashHistory} from 'react-router';
import {RaisedButton} from 'material-ui';
import fetch from 'node-fetch';
import {APP_VERSION} from '../libs/config';

class Login extends React.Component {

  constructor() {
    super();
    this.state = {
      url: '',
      username: '',
      password: ''
    }
  }

  onChangeURL = e => this.setState({url: e.target.value});
  onChangeUser = e => this.setState({username: e.target.value});
  onChangePass = e => this.setState({password: e.target.value});
  onSubmit = (e) => {
    e.preventDefault();
    const {url, username, password} = this.state;
    let options = {
      method: 'POST',
      body: JSON.stringify({username, password}),
      headers: {'Content-Type': 'application/json', Accept: 'application/json'}
    };

    fetch(`https://${url}/auth/login`, options)
      .then(res => res.json())
      .then((res) => {
        if(res.token){
          window.localStorage.token = res.token;
          window.localStorage.tss_url = url;
          hashHistory.replace('/');
        }else{
          console.log(res);
          alert(res.message);
        }
      });
  };

  render() {
    return (
      <div className="container">
        <section id="content">
          <h3 className="p-text-color" style={{marginTop: '0px'}}>TSS Data Entry</h3>
          <h5>v{APP_VERSION}</h5>
          <br/>
          <form id="form">
            <h1>Login</h1>
            <div>
              <input type="text" placeholder="TSS URL" id="url" onChange={this.onChangeURL}/>
            </div>
            <div>
              <input type="text" placeholder="Username" id="username" onChange={this.onChangeUser}/>
            </div>
            <div>
              <input type="password" placeholder="Password" id="password" onChange={this.onChangePass}/>
            </div>
            <div>
              <RaisedButton type="submit" label="Log in" primary={true}
                            style={{marginTop: '10px', marginBottom: '20px'}} onClick={this.onSubmit}/>
            </div>
          </form>
        </section>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js